// The portal theme switcher (ADR-0032) — a compact <select> in the app header
// that swaps the vaporwave flavor live. Keeps the choice in useTheme (mirrored to
// <html data-flavor> + localStorage). Deliberately small: three presets, no
// per-channel colour editing.

import { useTheme, FLAVORS, FLAVOR_LABELS, type Flavor } from "../useTheme";

export function ThemeSwitcher(): React.JSX.Element {
  const [flavor, setFlavor] = useTheme();
  return (
    <label className="theme-switch" title="Portal theme">
      <span className="theme-switch__icon" aria-hidden="true">◐</span>
      <span className="theme-switch__label">Theme</span>
      <select
        aria-label="Portal theme"
        value={flavor}
        onChange={(e) => setFlavor(e.target.value as Flavor)}
        data-testid="theme-switch"
      >
        {FLAVORS.map((f) => (
          <option key={f} value={f}>{FLAVOR_LABELS[f]}</option>
        ))}
      </select>
    </label>
  );
}
